import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=610b47e2&"
import script from "./tree.vue?vue&type=script&lang=js&"
export * from "./tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-tree-org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610b47e2')) {
      api.createRecord('610b47e2', component.options)
    } else {
      api.reload('610b47e2', component.options)
    }
    module.hot.accept("./tree.vue?vue&type=template&id=610b47e2&", function () {
      api.rerender('610b47e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tree/tree.vue"
export default component.exports